webpackJsonp([1],{

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app"
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      CardTypeAttr: {
        hasShopName: false,
        hasWifi: false,
        CardQrcodeCount: 1
      }
    };
  },

  props: ["Card_type", "Card_ImgPath"]
});

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_QrcodeTypeCard_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_QrcodeTypeCard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_QrcodeTypeCard_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      CardRadio: "",
      OSS_URL: this.$store.getters.get_ossURL + "/images",
      commonStyle: "middle-thumbnail",
      cardTypeList: ["1-1", "2-1", "2-1-1", "2-2", "2-2-1", "2-3", "2-5", "3-1", "3-1-1", "3-3", "3-4", "3-4-1", "3-6", "3-7", "4-1", "4-3", "5-1", "5-2", "5-3", "5-4", "5-5", "5-6", "D-1", "D-2", "D-3", "E-1", "E-2", "E-3"]
    };
  },

  watch: {
    CardRadio: function CardRadio(data) {
      // this.$store.state.Card_type=data;
      this.$store.dispatch("set_Card_type", data);
    }
  },
  components: {
    QrcodeTypeCard: __WEBPACK_IMPORTED_MODULE_1__components_QrcodeTypeCard_vue___default.a
  },
  methods: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_fontOptions__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_fontOptions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__store_fontOptions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fontOptions: __WEBPACK_IMPORTED_MODULE_1__store_fontOptions___default.a,
      qrcodeUrl: {
        wechatPay: "",
        wechatFriend: "",
        AliPay: "",
        officialAccount: "",
        SpecialOne: ""
      },
      dialogImageUrl: "",
      dialogVisible: false,
      fileList: [],
      Sumitted: false,
      isShowLoading: false,
      completeFill: true,
      isShowSelectLoading: false,

      ruleForm: {
        ShopName: "",
        ShopNameColor: "#000",
        wifiAccount: "",
        wifiPassword: "",
        FontType: [],
        ShopPhone: "",
        WangWangID: "",
        QrcodeDes: "",
        ShopNameImgDataURL: ""
      },
      qrcodePreviewDataURL: this.$store.getters.get_ossURL + "/whiteNoQrcode/" + this.$store.getters.get_Card_type + ".png/middle-thumbnail",
      fontPreviewDataURL: "",

      rules: {
        ShopName: [{ required: true, message: "请输入店铺名称", trigger: "blur" }, {
          min: 1,
          max: 12,
          message: "长度在十五个中文字以内",
          trigger: "blur"
        }],
        FontType: [{ required: false, message: "请选择字体", trigger: "change" }],
        ShopPhone: [{ required: false, message: "请填写联系电话", trigger: "blur" }],
        WangWangID: [{ required: true, message: "请填写你的旺旺ID", trigger: "blur" }],
        wifiAccount: [{ required: true, message: "请填写WiFi账号", trigger: "blur" }],
        wifiPassword: [{ required: true, message: "请填写WiFi密码", trigger: "blur" }],
        QrcodeDes: [{
          required: true,
          message: "请填写二维码下方描述文字",
          trigger: "blur"
        }]
      },
      resultForm: {
        wechatPayURL: "",
        aliPayURL: "",
        wechatFriendURL: "",
        wechatOfficialURL: ""
      }
    };
  },

  mounted: function mounted() {
    //滚动条回到顶部
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    //获取当前模板类型
    if (this.$store.getters.get_Card_type == "") {
      // this.$message.info('刷新后 请重新选择模板');
      this.$router.push("/");
      // this.clearCookies();
    }
  },
  computed: {
    hasShopName: function hasShopName() {
      return this.$store.getters.get_hasShopName;
    },
    hasWifi: function hasWifi() {
      return this.$store.getters.get_hasWifi;
    },
    CardQrcodeCount: function CardQrcodeCount() {
      return this.$store.getters.get_CardQrcodeCount;
    },
    Card_Type: function Card_Type() {
      return this.$store.getters.get_Card_type;
    },
    Card_ImgPath: function Card_ImgPath() {
      return "./static/preview/" + this.$store.getters.get_Card_type + ".jpg";
    },
    getTemplateOpts: function getTemplateOpts() {
      return {
        templateType: "t-" + this.$store.getters.get_Card_type,
        fontType: this.ruleForm.FontType[this.ruleForm.FontType.length - 1],
        shopName: this.ruleForm.ShopName,
        ShopNameColor: this.ruleForm.ShopNameColor,
        WangWangID: this.ruleForm.WangWangID,
        WifiName: this.ruleForm.wifiAccount,
        WifiPwd: this.ruleForm.wifiPassword,

        wechatPayURL: this.resultForm.wechatPayURL,
        aliPayURL: this.resultForm.aliPayURL,
        wechatFriendURL: this.resultForm.wechatFriendURL,
        wechatOfficialURL: this.resultForm.wechatOfficialURL
      };
    }
  },

  methods: {
    clearResultForm: function clearResultForm() {
      for (var attr in this.resultForm) {
        this.resultForm[attr] = "";
      }
      console.log("this.resultForm:" + this.resultForm);
    },
    submitUpload: function submitUpload() {
      this.$refs.eleupload.submit();
    },
    getFontPreview: function getFontPreview() {
      var that = this;
      console.log(this.ruleForm.ShopName);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/fontPreview/", {
        shopName: that.ruleForm.ShopName,
        ShopNameColor: that.ruleForm.ShopNameColor,
        fontType: that.ruleForm.FontType[this.ruleForm.FontType.length - 1]
      }).then(function (res) {
        that.fontPreviewDataURL = res.data;
      });
      this.getQrcodePreview();
    },
    getQrcodePreview: function getQrcodePreview() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/qrcodePreview/", this.getTemplateOpts).then(function (res) {
        console.log(res);
        _this.qrcodePreviewDataURL = res.data;
      });
    },
    handleRemove: function handleRemove(file, fileList) {
      this.$refs.eleupload.clearFiles();
      this.clearResultForm();
      this.getQrcodePreview();
      this.isShowLoading = false;
    },
    getCookie: function getCookie(name) {
      var arr,
          reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

      if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
    },
    submitQrcode: function submitQrcode() {
      var that = this;
      if (this.isShowLoading) {
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
          title: "二维码尚未完成识别",
          text: "请稍后再试,或重新上传",
          type: "info"
        });
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()({
        title: "要提交吗?",
        text: "请检查填写信息是否完整，提交完成后和客服确认",
        type: "info",
        buttons: ["我再检查一下", "提交"],
        confirmButtonColor: "#13ce66",
        cancelButtonText: "",
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }).then(function (value) {
        if (!value) {
          return;
        }

        that.UploadPicAndInfo();
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    UploadPicAndInfo: function UploadPicAndInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("/api/generateQrcode/convert/", this.getTemplateOpts).then(function (res) {
        console.log(res);
        __WEBPACK_IMPORTED_MODULE_2_sweetalert___default()("提交成功", "谢谢你的光临", "success");
        _this2.clearResultForm();
      }).then(function () {
        _this2.getQrcodePreview();
      });
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureError: function handlePictureError(err, file, fileList) {
      console.log(err);
      this.$message.error("图片上传失败");
      this.isShowLoading = false;
    },
    setResultForm: function setResultForm(key, value) {
      this.resultForm[key] = value;
    },
    saveResult: function saveResult(qrcodeURL) {
      var CheckqrcodeURL = qrcodeURL.toLowerCase();
      var isWechatPayURL = CheckqrcodeURL.indexOf("wxp://") >= 0 || CheckqrcodeURL.indexOf("payapp.weixin") >= 0 || CheckqrcodeURL.indexOf("wx.tenpay") >= 0;

      if (CheckqrcodeURL.indexOf("alipay") >= 0) {
        this.setResultForm("aliPayURL", qrcodeURL);
      }
      //微信支付
      else if (isWechatPayURL) {
          this.setResultForm("wechatPayURL", qrcodeURL);
        }
        //微信加好友
        else if (CheckqrcodeURL.indexOf("u.wechat") >= 0) {
            this.setResultForm("wechatFriendURL", qrcodeURL);
          }
          //微信公众号
          else if (CheckqrcodeURL.indexOf("weixin.qq") >= 0) {
              this.setResultForm("wechatOfficialURL", qrcodeURL);
            }
    },
    handlePictureSuccess: function handlePictureSuccess(res, file, fileList) {
      console.log(res);
      if (res.status == 1) {
        this.$message.success(res.msg);
        this.saveResult(res.note);
      } else {
        this.$message.error(res.msg);
        this.$refs.eleupload.clearFiles();
        this.clearResultForm();
      }
      this.getQrcodePreview();
      this.isShowLoading = false;
    },
    beforeUpload: function beforeUpload(file) {
      var isJPG = file.type === "image/jpeg";
      var isPNG = file.type === "image/png";
      var isLt5M = file.size / 1024 / 1024 < 5;
      this.isShowLoading = true;

      if (!(isJPG || isPNG)) {
        this.$message.error("上传的图片只能是 JPG 或 PNG 格式!");
        this.isShowLoading = false;
      }
      if (!isLt5M) {
        this.$message.error("上传的单张图片大小不能超过 5MB!");
        this.isShowLoading = false;
      }
      return (isJPG || isPNG) && isLt5M;
    },
    toggleShowLoading: function toggleShowLoading() {
      this.isShowLoading = !this.isShowLoading;
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lazyload__ = __webpack_require__(86);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_lazyload__["a" /* default */], {
  lazyComponent: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store_store_js__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

module.exports = [{
    value: 'zh-cn',
    label: '中文字体',
    children: [{
        value: 'chuantong',
        label: '传统经典',
        children: [{
            value: "simhei",
            label: "黑体(默认)"
        }, {
            value: "xkjt",
            label: "行楷简体"
        }, {
            value: "fzzyjt",
            label: "稚艺简体"
        }, {
            value: "hwls",
            label: "华文隶书"
        }, {
            value: "hycxjt",
            label: "汉仪程行简体"
        }, {
            value: "hyswss",
            label: "汉仪尚魏手书"
        }, {
            value: "fzljd",
            label: "方正吕建德字体简"
        }]
    }, {
        value: 'wenyi',
        label: '文艺清雅',
        children: [{
            value: "nssj",
            label: "南宋书局"
        }, {
            value: "wyjt",
            label: "夜未央"
        }, {
            value: "ssrj",
            label: "秘密日记"
        }, {
            value: "xhjn",
            label: "杏花江南"
        }, {
            value: "pfzl",
            label: "平凡之路"
        }, {
            value: "wtxy",
            label: "梧桐细雨"
        }, {
            value: "mmxj",
            label: "默陌信笺"
        }]
    }, {
        value: 'gufeng',
        label: '毛笔古风',
        children: [{
            value: "dnmbxsxdb",
            label: "段宁毛笔"
        }, {
            value: "dfp",
            label: "东风破"
        }, {
            value: "cmys",
            label: "草木一生"
        }, {
            value: "bxgh",
            label: "八仙过海"
        }, {
            value: "hjsd",
            label: "黄金时代"
        }]
    }, {
        value: 'kawayii',
        label: '卡哇萌系',
        children: [{
            value: "hdmxj",
            label: "蝴蝶喵小姐"
        }, {
            value: "mdtkzc",
            label: "猫的天空之城"
        }, {
            value: "lyy",
            label: "乐悠悠"
        }, {
            value: "hksn",
            label: "华康少女"
        }, {
            value: "tmxns",
            label: "甜蜜小女生"
        }, {
            value: "yqmm",
            label: "元气满满"
        }, {
            value: "mtr",
            label: "木头人"
        }]
    }]
}, {
    value: 'en',
    label: '英文字体',
    children: [{

        value: 'alsmyxj',
        label: '爱丽丝梦游仙境'
    }, {
        value: 'aqkxq',
        label: '爱情狂想曲'
    }, {
        value: 'ckxt',
        label: '刺客信条'
    }, {
        value: 'tlms',
        label: '提拉米苏'
    }, {
        value: 'ctsdm',
        label: '窗台上的猫'
    }]

}];

/***/ }),

/***/ 187:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 189:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 190:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(204),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(205),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "card-item"
  }, [_c('div', {
    staticClass: "card-control"
  }, [_c('el-radio', {
    staticClass: "img-radio",
    attrs: {
      "label": _vm.Card_type
    }
  }, [_vm._v("\n          " + _vm._s(_vm.Card_type) + "款式\n          "), _c('lazy-component', [_c('img', {
    staticClass: "card-img",
    attrs: {
      "src": _vm.Card_ImgPath,
      "alt": _vm.Card_type + '型号模板'
    }
  })])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qcode"
  }, [_c('header', [_c('div', {
    staticClass: "headerTitle"
  }, [_c('h1', [_vm._v("请选择模板")]), _vm._v(" "), _c('el-steps', {
    attrs: {
      "active": 0,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "选模板",
      "icon": "el-icon-picture"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "填信息",
      "icon": "el-icon-edit"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "上传",
      "icon": "el-icon-upload"
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "el-radio-myStyle",
    model: {
      value: (_vm.CardRadio),
      callback: function($$v) {
        _vm.CardRadio = $$v
      },
      expression: "CardRadio"
    }
  }, [_c('ul', [_vm._l((_vm.cardTypeList), function(cardType) {
    return [_c('QrcodeTypeCard', {
      key: 'card' + cardType,
      attrs: {
        "Card_type": cardType,
        "Card_ImgPath": (_vm.OSS_URL + "/" + cardType + ".jpg/" + _vm.commonStyle)
      }
    })]
  }), _vm._v(" "), _c('el-badge', {
    staticClass: "item",
    attrs: {
      "value": "Beta"
    }
  }, [_c('p', [_vm._v("以下是彩色版测试")])]), _vm._v(" "), _c('QrcodeTypeCard', {
    attrs: {
      "Card_type": 'color-2',
      "Card_ImgPath": (_vm.OSS_URL + "/color-2.jpg/" + _vm.commonStyle)
    }
  })], 2)]), _vm._v(" "), _c('footer', [_c('div', {
    staticClass: "footer"
  }, [_c('router-link', {
    attrs: {
      "to": "/WriteInfo"
    }
  }, [_c('Button', {
    staticClass: "next_btn",
    class: {
      'next_btn_disabled': _vm.CardRadio == ''
    },
    attrs: {
      "disabled": _vm.CardRadio == ''
    }
  }, [_vm._v("\n                下一步\n            ")])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.Sumitted),
      expression: "!Sumitted"
    }],
    staticClass: "Sumitted_Hidden"
  }, [_c('header', [_c('div', {
    staticClass: "headerTitle"
  }, [_c('h1', {
    staticStyle: {
      "font-weight": "100"
    }
  }, [_c('el-button-group', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-back"
    }
  })], 1)], 1), _vm._v("\n                请填写相关信息\n            ")], 1), _vm._v(" "), _c('el-steps', {
    attrs: {
      "active": 1,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    attrs: {
      "title": "选模板",
      "icon": "el-icon-picture"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "填信息",
      "icon": "el-icon-edit"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "上传",
      "icon": "el-icon-upload"
    }
  })], 1)], 1)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasShopName || _vm.hasWifi),
      expression: "hasShopName||hasWifi"
    }],
    staticClass: "WriteinfoPanel"
  }, [_vm._m(0), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "80px"
    }
  }, [(_vm.hasShopName) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "ShopName",
      "placeholder": ""
    }
  }, [_c('el-input', {
    on: {
      "blur": _vm.getFontPreview
    },
    model: {
      value: (_vm.ruleForm.ShopName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ShopName", $$v)
      },
      expression: "ruleForm.ShopName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.$store.getters.get_Card_type.indexOf('color') >= 0) ? _c('el-form-item', {
    attrs: {
      "label": "字体颜色",
      "prop": "ShopNameColor",
      "placeholder": ""
    }
  }, [_c('el-color-picker', {
    on: {
      "change": _vm.getFontPreview
    },
    model: {
      value: (_vm.ruleForm.ShopNameColor),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "ShopNameColor", $$v)
      },
      expression: "ruleForm.ShopNameColor"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasShopName),
      expression: "hasShopName"
    }],
    attrs: {
      "label": "店名字体"
    }
  }, [_c('el-cascader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasShopName),
      expression: "hasShopName"
    }],
    attrs: {
      "placeholder": "请选择字体",
      "options": _vm.fontOptions,
      "show-all-levels": false
    },
    on: {
      "change": _vm.getFontPreview
    },
    model: {
      value: (_vm.ruleForm.FontType),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "FontType", $$v)
      },
      expression: "ruleForm.FontType"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.fontPreviewDataURL,
      "id": "fontPreview"
    }
  })], 1), _vm._v(" "), (_vm.hasWifi) ? _c('el-form-item', {
    attrs: {
      "label": "WiFi账号",
      "prop": "wifiAccount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "中文8个字内,英文12个字内"
    },
    on: {
      "blur": _vm.getQrcodePreview
    },
    model: {
      value: (_vm.ruleForm.wifiAccount),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "wifiAccount", $$v)
      },
      expression: "ruleForm.wifiAccount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasWifi) ? _c('el-form-item', {
    attrs: {
      "label": "WiFi密码",
      "prop": "wifiPassword"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "长度建议小于14位"
    },
    on: {
      "blur": _vm.getQrcodePreview
    },
    model: {
      value: (_vm.ruleForm.wifiPassword),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "wifiPassword", $$v)
      },
      expression: "ruleForm.wifiPassword"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v("你需要上传"), _c('span', {
    staticClass: "hightlightText"
  }, [_vm._v(_vm._s(_vm.CardQrcodeCount))]), _vm._v("个二维码"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowLoading),
      expression: "isShowLoading"
    }],
    staticClass: "upload-Loading"
  }, [_c('i', {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "2em"
    }
  }), _c('p', [_vm._v("智能识别中...")])])]), _vm._v(" "), _c('el-upload', {
    ref: "eleupload",
    attrs: {
      "list-type": "picture-card",
      "drag": "",
      "accept": "image/jpeg,image/png",
      "action": "/api/uploadImgAndGetURL/",
      "auto-upload": true,
      "on-success": _vm.handlePictureSuccess,
      "on-error": _vm.handlePictureError,
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove,
      "before-upload": _vm.beforeUpload,
      "file-list": _vm.fileList,
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("仅支持jpg/png格式，且小于5MB的清晰图片")])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-picture"
  }), _vm._v("预览模板：" + _vm._s(this.$store.getters.get_Card_type) + " ")]), _vm._v(" "), _c('img', {
    staticClass: "card-img",
    attrs: {
      "src": _vm.qrcodePreviewDataURL,
      "alt": this.$store.getters.get_Card_type + '型号模板'
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_vm._m(1), _vm._v(" "), _c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "auto"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "旺旺名称",
      "prop": "WangWangID"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.ruleForm.WangWangID),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "WangWangID", $$v)
      },
      expression: "ruleForm.WangWangID"
    }
  })], 1)], 1), _vm._v(" "), _c('Button', {
    staticClass: "submit_btn",
    class: {
      'submit_btn_disabled': !this.ruleForm.WangWangID.trim() != ''
    },
    attrs: {
      "disabled": this.ruleForm.WangWangID.trim() == ''
    },
    on: {
      "click": _vm.submitQrcode
    }
  }, [_vm._v("\n        完成\n      ")])], 1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-edit"
  }), _vm._v("模板信息")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-info"
  }), _vm._v("买家信息")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "WriteinfoPanel"
  }, [_c('p', {
    staticClass: "section_title"
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _vm._v("客户须知")]), _vm._v(" "), _c('ul', {
    staticClass: "userTips"
  }, [_c('li', [_vm._v("为了防止出现错漏，提交后请"), _c('span', {
    staticClass: "hightlightText"
  }, [_vm._v("注意跟客服进行确认")]), _vm._v("。")]), _vm._v(" "), _c('li', [_vm._v("诚信木匠提供服务")])])])
}]}

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 82:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SelectQcodeType__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SelectQcodeType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_SelectQcodeType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WriteInfo__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_WriteInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_WriteInfo__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    name: "SelectQcodeType",
    component: __WEBPACK_IMPORTED_MODULE_2__components_SelectQcodeType___default.a
  }, {
    path: "/WriteInfo",
    name: "WriteInfo",
    component: __WEBPACK_IMPORTED_MODULE_3__components_WriteInfo___default.a
  }]
}));

/***/ }),

/***/ 83:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(209);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    Card_type: "",
    hasShopName: false,
    hasWifi: false,
    CardQrcodeCount: 1,
    ossURL: "//cdn.52cxmj.xyz/cdn/cxmj-qrcodehandler-front"
  },
  mutations: {
    SET_CARD_TYPE: function SET_CARD_TYPE(state, value) {
      state.Card_type = value.Card_type;
      state.hasShopName = value.hasShopName;
      state.hasWifi = value.hasWifi;
      state.CardQrcodeCount = value.CardQrcodeCount;
    }
  },
  actions: {
    set_Card_type: function set_Card_type(_ref, value) {
      var commit = _ref.commit;

      var Card_type = value;
      var hasShopName = void 0;
      var hasWifi = void 0;
      var CardQrcodeCount = void 0;

      var setAttribute = function setAttribute(attr_Card_type, attr_hasShopName, attr_hasWifi, attr_CardQrcodeCount) {
        Card_type = attr_Card_type;
        hasShopName = attr_hasShopName;
        hasWifi = attr_hasWifi;
        CardQrcodeCount = attr_CardQrcodeCount;
      };

      switch (Card_type) {
        case "1-1":
          setAttribute("1-1", true, false, 1);
          break;
        case "2-1":
          setAttribute("2-1", false, false, 2);
          break;
        case "2-1-1":
          setAttribute("2-1-1", false, false, 2);
          break;
        case "2-2":
          setAttribute("2-2", false, false, 2);
          break;
        case "2-2-1":
          setAttribute("2-2-1", false, false, 2);
          break;
        case "2-3":
          setAttribute("2-3", false, true, 2);
          break;
        case "2-5":
          setAttribute("2-5", false, false, 2);
          break;
        case "3-1":
          setAttribute("3-1", false, false, 3);
          break;
        case "3-1-1":
          setAttribute("3-1-1", false, false, 3);
          break;
        case "3-3":
          setAttribute("3-3", true, false, 3);
          break;
        case "3-4":
          setAttribute("3-4", true, false, 3);
          break;
        case "3-4-1":
          setAttribute("3-4-1", true, false, 3);
          break;
        case "3-6":
          setAttribute("3-6", true, false, 2);
          break;
        case "3-7":
          setAttribute("3-7", true, true, 2);
          break;

        case "4-1":
          setAttribute("4-1", true, true, 3);
          break;

        case "4-3":
          setAttribute("4-3", true, false, 3);
          break;
        case "4-4":
          setAttribute("4-4", true, false, 3);
          break;
        case "5-1":
          setAttribute("5-1", true, false, 2);
          break;
        case "5-2":
          setAttribute("5-2", false, false, 2);
          break;
        case "5-3":
          setAttribute("5-3", true, false, 3);
          break;
        case "5-4":
          setAttribute("5-4", true, false, 3);
          break;
        case "5-5":
          setAttribute("5-5", true, false, 3);
          break;
        case "5-6":
          setAttribute("5-6", true, false, 2);
          break;

        case "D-1":
          setAttribute("D-1", true, false, 2);
          break;
        case "D-2":
          setAttribute("D-2", true, false, 2);
          break;
        case "D-3":
          setAttribute("D-3", true, true, 1);
          break;
        case "E-1":
          setAttribute("E-1", false, false, 1);
          break;
        case "E-2":
          setAttribute("E-2", false, false, 1);
          break;
        case "E-3":
          setAttribute("E-3", false, false, 1);
          break;
        case "color-2":
          setAttribute("color-2", true, false, 2);
          break;
        default:
          break;
      }

      //提交
      commit("SET_CARD_TYPE", {
        Card_type: Card_type,
        hasShopName: hasShopName,
        hasWifi: hasWifi,
        CardQrcodeCount: CardQrcodeCount
      });
    }
  },
  getters: {
    get_CardQrcodeCount: function get_CardQrcodeCount(state) {
      return state.CardQrcodeCount;
    },
    get_Card_type: function get_Card_type(state) {
      return state.Card_type;
    },
    get_hasShopName: function get_hasShopName(state) {
      return state.hasShopName;
    },
    get_hasWifi: function get_hasWifi(state) {
      return state.hasWifi;
    },
    get_ossURL: function get_ossURL(state) {
      return state.ossURL;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 85:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(28)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(206),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

},[132]);


// WEBPACK FOOTER //
// static/js/app.1abcd4eca7a480d7942a.js